import Immutable from 'immutable';
import {
  CLEAR_ITINERARY_ADDITIONAL_FOODS,
  FLAG_ITINERARY_ADDITIONAL_FOOD_ACTIVITY,
  FLAG_ITINERARY_ADDITIONAL_FOODS,
  GET_ITINERARY_ADDITIONAL_FOODS,
} from '../../../actions/types/itinerary/ItineraryAdditionalFood';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.List(),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FLAG_ITINERARY_ADDITIONAL_FOODS:
      return state.setIn(['all', 'loading'], action.payload);

    case GET_ITINERARY_ADDITIONAL_FOODS:
      return state.setIn(
        ['all', 'content'],
        Immutable.fromJS(Array.isArray(action.payload) ? action.payload : []),
      );

    case CLEAR_ITINERARY_ADDITIONAL_FOODS:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );

    case FLAG_ITINERARY_ADDITIONAL_FOOD_ACTIVITY:
      if (action.payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(action.payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );

    default:
      return state;
  }
};
